export default {
  DARK: {
    workingHours: p => p.primaryLight,
    background: p => `${p.tertiaryDark}`,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    workingHours: p => p.primaryDark,
    background: p => `${p.tertiaryLight}`,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    workingHours: p => p.primaryDark,
    background: p => `${p.tertiaryExtraLight}`,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
